// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fc423aec","453":"9b399fe2","455":"ac7e0e63","977":"1d34a368"}[chunkId] + ".chunk.js";
};